import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=bc268cd2&scoped=true&"
import script from "./GlobalLoading.vue?vue&type=script&lang=ts&"
export * from "./GlobalLoading.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=bc268cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc268cd2",
  null
  
)

export default component.exports